import styled from "styled-components";

export const ProjectText = styled.div`
  font-family: var(--robo);
  font-size: 1rem;
  background-color: var(--light);
  padding: 0.5rem;
  border-radius: 1rem;
  border: 1px solid black;
  color: black;
  text-align: center;

  /* shadow effect */
  -moz-box-shadow: 7px 6px 5px 2px black;
  -webkit-box-shadow: 7px 6px 5px 2px black;
  box-shadow: 7px 6px 5px 2px black;
`;
